import { defineStore } from 'pinia';
import { SESSION_STORAGE_GDPR_KEY } from '@/stores/constants.js';
import { configGetter } from '@/config/configGetter.js';

export const useGdprStore = defineStore('gdpr', {
  state: () => ({
    gdprConsent: JSON.parse(
      sessionStorage.getItem(SESSION_STORAGE_GDPR_KEY) || '{}'
    )
  }),
  actions: {
    setGdprConsent(payload) {
      this.gdprConsent[payload.tenantId] = payload.value;
      sessionStorage.setItem(
        SESSION_STORAGE_GDPR_KEY,
        JSON.stringify(this.gdprConsent)
      );
    }
  },
  getters: {
    hasGdprConsent: state => tenantId => {
      return configGetter(tenantId).gdprApproved || state.gdprConsent[tenantId];
    }
  }
});
